<template>
	<div class="header">
		<div v-if="isMobile">
			<div class="header-box">
				<div class="flex align-center" @click="toIndex">
					<img class="logo" src="@/assets/logo.png" alt="" />
					<div>
						<div class="title">广东省工业新材料协会</div>
						<div class="name">GUANGDONG INDUSTRIAL ADVANCED MATERIALS ASSOCIATION</div>
					</div>
				</div>
				<div @click="drawer=true" class="menu-icon">
					<img src="@/assets/menu-icon.png" alt="" />
				</div>
			</div>
			<div class="menu" :class="{'menu-on':drawer}" @click="drawer=false">
				<div class="header-nav" :class="{'nav-on':drawer}" @click.stop="">
					<div class="drawer-close" @click="drawer=false">
						<div>菜单</div>
						<i class="el-icon-close"></i>
					</div>
					<div v-for="(item, index) in list" :key="index" class="header-text" @click="topage(item,index)">
						<div class="top-title flex align-center justify-between"
							:class="{'top-title-on header-text-active': index == menuIndex.index}">
							{{item.title}}
							<i v-if="item.list" class="el-icon-arrow-right" :class="{'i-on':item.junior}"></i>
						</div>
						<el-collapse-transition>
							<div class="ul" v-if="item.junior">
								<div class="li"
									:class="{'header-text-active': index == menuIndex.index&&index_ == menuIndex.index_}"
									v-for="(item_,index_) in item.list" :key="index_"
									@click.stop="topage(item_,index,index_)">{{item_.title}}</div>
							</div>
						</el-collapse-transition>
					</div>
				</div>
			</div>
		</div>
		<div v-else>
			<div class="header-box">
				<a class="logo" href="http://beta.advancedmaterials.org.cn/" @click="toIndex">
					<div class="title">
						<span class="zh">广东新材料大数据平台</span>
						<span class="title-sub">Guangdong Advanced Materials Big Data Platform</span>
					</div>
					<div class="name">
						<span class="zh">国家新材料资源共享平台粤港澳大湾区分平台</span>
						<span class="en" style="font-size: 14px;">National Advanced Materials Resource Sharing Platform – GBA Sub-Platform</span>
					</div>
				</a>
				<div class="search-box">
					<div class="search">
						<input class="input" type="text" placeholder="请输入想要搜索的内容" />
						<div class="btn" @click="searchSub">搜索</div>
					</div>
					<div class="date">
						<div class="calendar">{{solarDate}}&nbsp;&nbsp;{{nowWeek}}&nbsp;&nbsp;{{lunarDate}} </div>
						<!-- <div class="header-lanage">
							<div class="header-label active">中文</div>
							<div class="header-label">English</div>
							<div class="header-label">한국어</div>
						</div> -->
					</div>
				</div>
			</div>
			<div style="width: 100%;background-color: #D71418;position: relative;">
				<img class="navbg" src="@/assets/navbg.png" alt="" />
				<div class="header-nav">
					<div v-for="(item, index) in list" :key="index" class="header-text"
						:class="{'active': index == menuIndex.index}" @click="topage(item,index)">{{item.title}}
						<div class="ul">
							<div class="li" :class="{'on': index == menuIndex.index&&index_ == menuIndex.index_}"
								v-for="(item_,index_) in item.list" :key="index_"
								@click.stop="topage(item_,index,index_)">{{item_.title}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import solarlunar from 'solarlunar';
	export default {
		name: 'headern',
		data() {
			return {
				list: [{
						title: "首页",
						to: {
							path: "/"
						}
					},
					{
						title: "党建工作",
						junior: false,
						list: [{
								title: "党建头条",
								to: {
									path: '/foundparty/list?id=24',
								}
							},
							{
								title: "党建活动",
								to: '/foundparty/list?id=25'
							},
							{
								title: "组织结构",
								to: '/foundparty/list?id=26'
							}
						]
					},
					{
						title: "大数据平台",
						to: 'false'
					},
					{
						title: "标准与知识产权",
						junior: false,
						list: [{
								title: "政策宣贯",
								to: {
									path: '/foundparty/list?id=44',
								}
							}, {
								title: "标准与认证",
								to: {
									path: '/news/list?id=2',
								}
							},
							{
								title: "知识产权",
								to: {
									path: '/news/list?id=3',
								}
							}
						]
					},
					{
						title: "云上会展",
						junior: false,
						list: [{
								title: "云上看展",
								to: {
									path: "/exhibition/cloud?id=47"
								},
							},
							{
								title: "线下展览",
								to: {
									path: "/exhibition/offline?type=2"
								},
							},
							{
								title: "视频直播",
								to: {
									path: "/exhibition/live?id=48"
								},
							},
							{
								title: "企业展厅",
								to: {
									path: "/company/list"
								},
							}
						]
					},
					{
						title: "中试平台",
						junior: false,
						list: [{
								title: "政策宣贯",
								to: {
									path: '/foundparty/list?id=45',
								}
							}, {
								title: "中试服务",
								to: {
									path: '/pilotplatform/list?id=35',
								}
							},
							{
								title: "实验室共享",
								to: 'false'
							}
						]
					},
					{
						title: "企业赋能",
						junior: false,
						list: [
							// {
							// 	title: "企业入驻",
							// 	to:'false'
							// },
							// {
							// 	title: "科技服务",
							// 	to: {
							// 		path: "/news/list?id=18",
							// 	},
							// },
							// {
							// 	title: "产品对接",
							// 	to: {
							// 		path: "/news/list?id=5",
							// 	},
							// },
							// {
							// 	title: "成果转换",
							// 	to: {
							// 		path: "/news/list?id=19",
							// 	},
							// }
							{
								title: "政策宣贯",
								to: '/news/list?id=37'
							},
							{
								title: "服务专项",
								to: {
									path: "/news/list?id=38",
								},
							},
							{
								title: "产业链对接",
								to: {
									path: "/news/list?id=19",
								},
							},
							{
								title: "产学研金用合作",
								to: {
									path: "/news/list?id=40",
								},
							}
						]
					},
					{
						title: "培训研学",
						junior: false,
						list: [{
								title: "国内研学",
								to: {
									path: "/train/list?id=15",
								},
							},
							{
								title: "国外研学",
								to: {
									path: "/train/list?id=16",
								},
							},
							{
								title: "线上培训",
								to: {
									path: "/train/list?id=17",
								},
							}
						]
					},
					{
						title: "协会活动",
						junior: false,
						list: [{
							title: "会展通知",
							to: {
								path: "/events/list?id=13",
							},

						}, {
							title: "活动报名",
							to: {
								path: "/events/list?id=14",
							},
						}]
					},
					{
						title: "科学普及",
						junior: false,
						list: [{
								title: "金属材料",
								to: {
									path: "/study/list?id=9",
								},
							},
							{
								title: "高分子材料",
								to: {
									path: "/study/list?id=10",
								},
							},
							{
								title: "无机非金属材料",
								to: {
									path: "/study/list?id=11",
								},
							},
							{
								title: "普及活动", // TODO
								to: {
									path: "/study/list?id=12",
								},
							}
						]
					},
					{
						title: "扶贫商城",
						to: 'false'
					},
					{
						title: "关于我们",
						junior: false,
						list: [{
								title: "协会简介",
								to: {
									path: "/aboutus/introduce?id=20",
								}
							},
							{
								title: "协会章程",
								to: {
									path: "/aboutus/introduce?id=21",
								}
							},
							{
								title: "组织架构",
								to: {
									path: "/aboutus/introduce?id=22",
								}
							},
							{
								title: "新材料产业分类名称",
								to: {
									path: "/aboutus/introduce?id=46",
								}
							},
							{
								title: "联系我们",
								to: {
									path: "/aboutus/introduce?id=23"
								}
							},
							{
								title: "表格下载",
								to: {
									path: "/aboutus/introduce?id=43"
								}
							},
						]
					},
				],
				menuIndex: {
					index: -1,
					index_: -1
				},
				solarDate: '',
				lunarDate: '',
				nowWeek: '',
				isMobile: this.isMoBile(),
				drawer: false,
			}
		},
		watch: {
			$route(to, from) {
				this.menuIndex.index = -1
				this.menuIndex.index_ = -1
				this.list.forEach((item, index) => {
					if (item.to && item.to.path == to.path) {
						this.menuIndex.index = index
					}
					if (item.list) {
						item.list.forEach((item_, index_) => {
							if (item_.to && item_.to.path == to.fullPath) {
								this.menuIndex.index = index
								this.menuIndex.index_ = index_
							}
						})
					}
				})
			},
			drawer(e) {
				if (e) {
					// 弹窗打开时禁止页面滚动
					document.body.style.overflow = 'hidden';
				} else {
					// 弹窗关闭时恢复页面滚动
					document.body.style.overflow = '';
				}
			}
		},
		mounted() {
			// 获取日期：年月日
			let date = new Date()
			const year = date.getFullYear()
			const month = date.getMonth() + 1
			const day = date.getDate()
			this.solarDate = year + "年" + month + "月" + day + "日"
			// 获取星期几
			const weeks = new Array("星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六")
			this.nowWeek = weeks[date.getDay()]
			// 转换为农历
			const lunar = solarlunar.solar2lunar(year, month, day);
			// 处理闰月显示
			const monthStr = lunar.isLeap ? `闰${lunar.monthCn}` : lunar.monthCn;
			// 组合结果
			this.lunarDate = `${lunar.gzYear}年${monthStr}${lunar.dayCn}`;
		},
		methods: {
			topage(item, index = -1, index_ = -1) {
				if (item.junior !== undefined) {
					item.junior = !item.junior
				}
				let to = item.to
				if (!to) return
				if (to == 'false') return this.$toast({
					message: '功能建设中~',
					type: 'error',
				})
				if (to.code) {
					window.open(to.url)
				} else if (this.menuIndex.index != index || this.menuIndex.index_ != index_) {
					this.drawer = false
					this.menuIndex.index = index
					this.menuIndex.index_ = index_
					this.$router.replace(to);
				}
			},
			searchSub() {
				this.$toast({
					message: '功能建设中~',
					type: 'error',
				})
			},
			toIndex() {
				const url = this.$route.path
				if (url == '/') {
					window.location.reload();
				} else {
					this.$router.replace({
						path: "/"
					});
				}
			}
		}
	}
</script>
<style lang="scss" scoped>
	@media screen and (min-width: 1000px) {
		.header {
			box-sizing: border-box;
			position: relative;
			z-index: 99;
			min-width: 1280px;
		}

		.header-box {
			padding: 10px 0;
			margin: 0 auto;
			background-color: #fefeff;
			display: flex;
			justify-content: space-between;
			align-items: center;
			width: 1280px;

			.logo {
				text-decoration: none;
				color: inherit;
				outline: none;
			}

			.title {
				color: #D71418;
				font-size: 44px;
				font-weight: bold;
				margin-bottom: 10px;
				line-height: 1.3;
				display: block;					
				text-transform: uppercase;
				letter-spacing: 10px;
				
			}
			.title-sub {
				display: block;
				font-size: 14px;
				line-height: 16px;
				letter-spacing:0.7px;
				font-weight: 400;
				color:#666;
			}

			.name {
				.zh {
					display: block;
					color: #D71418;
					text-transform: uppercase;
					font-size: 18px;
					letter-spacing: 10px;
					font-weight: 600;
				}
				.en {
					display: block;
					color: #666;
					text-transform: uppercase;
					font-size: 14px;
				}
			}
		}

		.header-nav {
			margin: 0 auto;
			width: 1280px;
			color: #fff;
			font-weight: 400;
			font-size: 14px;
			display: flex;
			justify-content: flex-start;
			align-items: center;
		}

		.header-text {
			padding: 0 24px;
			height: 50px;
			display: flex;
			justify-content: center;
			align-items: center;
			justify-content: center;
			cursor: pointer;
			position: relative;
		}

		.header-text.active,
		.header-text:hover {
			font-weight: bold;
			background-color: #b31015;
		}

		.header-text:hover .ul {
			visibility: visible;
			opacity: 1;
			margin-top: 0;
		}

		.ul {
			margin-top: 15px;
			opacity: 0;
			visibility: hidden;
			transition: all 0.3s ease-in-out;
			min-width: 100%;
			text-align: center;
			position: absolute;
			z-index: 99;
			background-color: #b31015;
			left: 0;
			top: 50px;
			color: #fff;
		}

		.ul .li {
			padding: 10px;
		}

		.ul .li:hover,
		.ul .on {
			color: #fff;
			background-color: #D71418;
		}
	}

	@media screen and (max-width: 999px) {
		.header {
			box-sizing: border-box;
			position: sticky;
			top: 0;
			z-index: 99;
			width: 100%;
		}

		.header-box {
			width: 100%;
			padding: 4vw;
			background-color: #fefeff;
			display: flex;
			justify-content: space-between;
			align-items: center;

			.logo {
				width: 12vw;
				height: 12vw;
				margin-right: 2.666666vw;
			}

			.title {
				color: #333;
				font-size: 4vw;
				font-weight: bold;
			}

			.name {
				margin-top: 2px;
				font-size: 2.3vw;
				font-weight: 600;
				color: #333;
			}

			.menu-icon {
				margin-left: 5.33333vw;

				img {
					width: 6.93555vw;
					height: 6.93555vw;
				}
			}
		}

		.menu {
			position: fixed;
			width: 100%;
			background-color: rgba(0, 0, 0, 0.4);
			top: 0;
			left: 0;
			bottom: 0;
			right: 0;
			z-index: 999;
			transition: .2s;
			opacity: 0;
			pointer-events: none;
			overflow-y: scroll;

		}

		.menu-on {
			opacity: 1;
			pointer-events: auto;
		}

		.drawer-close {
			font-size: 4vw;
			color: #333;
			font-weight: bold;
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 4vw;
			position: sticky;
			top: 0;
			z-index: 9999;
			background-color: #fff;
			border-bottom: 1px solid #eee;

			i {
				font-size: 6vw;
			}
		}

		.top-title {
			line-height: 13.33333vw;
		}

		.top-title-on::before {
			border-radius: 1vw;
			position: absolute;
			left: 0;
			content: '';
			height: 5.333339vw;
			width: 1vw;
			background-color: #D71418;
		}

		.header-nav {
			background-color: #fff;
			width: 50%;
			min-height: 100%;
			transition: .3s ease-in-out;
			transform: translate(-100%);
		}

		.nav-on {
			transform: translate(0);
		}

		.header-text {
			border-bottom: 1px solid #eee;
			padding: 0 4vw;
			display: flex;
			flex-direction: column;
			cursor: pointer;
			position: relative;
			font-size: 3.73333vw;

			i {
				transition: all .3s;
			}

			.i-on {
				transform: rotate(90deg);
			}
		}

		.header-text-active {
			color: #b31015;
		}

		.ul {
			.li {
				padding: 0 4vw;
				line-height: 13.33333vw;
			}
		}
	}
	
	.search-box {
		margin-top: 40px;
	}
	.header-box .search,
	.header-box .date {
		display: flex;
		align-items: center;
		justify-content: flex-start;
		margin-top: 10px;
		font-size: 13px;

	}

	.header-box .search .input {
		width: 260px;
		height: 40px;
		padding: 0 10px;
		border-radius: 0;
		font-size: 14px;
		border: 1px solid #D71418;
	}

	.header-box .search .btn {
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #fff;
		height: 40px;
		width: 70px;
		font-size: 14px;
		padding: 5px;
		border: 1px solid #D71418;
		background-color: #D71418;
	}

	.navbg {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 0;
		object-position: center;
		object-fit: cover;
	}


	.header-lanage {
		margin-left: 20px;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: #FFFFFF;
		border-radius: 3px;
	}

	.header-label {
		border-radius: 3px;
		text-align: center;
		font-size: 12px;
		padding: 5px 7px;
		box-sizing: border-box;
		user-select: none;
		cursor: pointer;
	}

	.header-label.active {
		background: #D71418;
		color: #FFFFFF;
	}
</style>